<script setup>
import {onMounted, ref, reactive, nextTick} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {userInfoStore} from "@/store/store.js";
import {getRoute} from "@/hooks/getRoute.js";
import {addMemberCreditLog, listMemberCreditLog} from "@/api/memberCreditLog/memberCreditLog.js";
import {listOperatorAdmin} from "@/api/user/user.js";
import {memberList} from "@/api/member/member.js";
/*获取路由信息*/
const {route} = getRoute()
/*初次加载*/
onMounted(async () => {
  // 获取路由的userId填充搜索表单
  if (route.query.userId) formData.userId = route.query.userId
  await handleGetOperator('init')
  await handleSearch()
})
// 用户信息
const userInfo = ref(userInfoStore().info);

/*搜索功能*/
// 表单数据
const formData = reactive({
  userId: null,
  crUserId: null
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listMemberCreditLog(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.userId = null
  formData.crUserId = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
// 表头信息
const headers = ref([
  { title: '用户ID', key: 'userId', nowrap: true },
  { title: '用户昵称', key: 'nickname', nowrap: true },
  { title: '手机号', key: 'phone', nowrap: true },
  { title: '变更积分', key: 'creditChange', nowrap: true },
  { title: '积分', key: 'finalCredit', nowrap: true },
  { title: '时间', key: 'crTime', nowrap: true },
  { title: '操作人', key: 'crUserName', nowrap: true },
  { title: '备注', key: 'reason', nowrap: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}
// 操作人列表
const memberListArr = ref([])
// 操作人总数条
const memberTotal = ref(0)
// 操作人翻页锚点
const YTTablePaginationMemberRef = ref()
// 处理操作人翻页
const handleChangeMemberPage = () => {
  handleGetOperator()
}
// 操作人列表加载状态
const operatorLoading = ref(false)
// 操作人下拉搜索值
const operatorSelectKey = ref()
// 处理搜索条件列表：操作人
const handleGetOperator = async (type) => {
  await nextTick(async () => {
    try {
      if (type === 'search') {
        YTTablePaginationMemberRef.value.resetPage()
      }
      let param = {
        page: type === 'init' ? 1 : YTTablePaginationMemberRef.value.getPage(),
        pageSize: type === 'init' ? 5 : YTTablePaginationMemberRef.value.getPageSize()
      }
      operatorLoading.value = true
      let res = null
      if (type === 'search') {
        res = await listOperatorAdmin(param, {adminType: 1, nickname: operatorSelectKey.value})
      } else {
        res = await listOperatorAdmin(param, {adminType: 1})
      }
      memberListArr.value = res.list
      memberTotal.value = parseInt(res.total)
      operatorLoading.value = false
    } catch (e) {
      console.log(e)
      operatorLoading.value = false
    }
  })
}
// 处理选择器选择操作人
const handleSelectOperator = (e) => {
  formData.crUserId = e
  console.log("formData", formData)
}

/*新建积分记录*/
// 新建积分记录弹窗状态
const open = ref(false)
// 对话框表单锚点
const dialogFormRef = ref()
// 对话框表单
const dialogForm = reactive({
  userId: null,
  creditChange: null,
  type: "PERSONAL",
  reason: null
})
// 对话框表单校验规则
const dialogRules = reactive({
  userId: [
    { required: true, message: "请选择用户", trigger: ['change', 'blur'] }
  ],
  creditChange: [
    { required: true, message: "请填写积分", trigger: ['change', 'blur'] }
  ],
  reason: [
    { required: true, message: "请填写备注", trigger: ['change', 'blur'] }
  ],
})
// 关闭对话框
const closeDialog = () => {
  clearDialog()
  open.value = false
}
// 确认新建积分记录
const submitDialog = async () => {
  dialogFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        loading.value = true
        const res = await addMemberCreditLog(dialogForm)
        ElMessage.success("新增成功")
        closeDialog()
        loading.value = false
        await handleSearch()
      } catch (e) {
        console.log(e)
        closeDialog()
        loading.value = false
      }
    } else {
      ElMessage({
        message: "请根据提示修改表单信息",
        type: "error",
      })
    }
  })
}
// 清除对话框表单校验
const clearDialog = () => {
  dialogForm.userId = null
  dialogForm.creditChange = null
  dialogForm.reason = null
  dialogFormRef.value.clearValidate()
}

/*弹窗表单相关*/
// 弹窗用户、卡券加载状态
const dialogLoading = ref(false)
// 弹窗用户列表
const dialogMemberList = ref([])
// 弹窗用户列表总条数
const dialogMemberTotal = ref(0)
// 处理弹窗用户列表翻页
const handleChangeDialogMemberPage = () => {
  handleGetUserList()
}
// 弹窗用户翻页锚点
const YTTablePaginationDialogMemberRef = ref()
// 用户列表搜索缓存
const cacheUserListKeyword = ref()
// 处理弹窗搜索用户列表
const handleUserListRemoteSearch = (keyword, type = 'init') => {
  cacheUserListKeyword.value = keyword
  handleGetUserList(type)
}
// 处理弹窗获取用户列表
const handleGetUserList = async (type = 'init') => {
  await nextTick(async () => {
    try {
      if (type === 'search') {
        YTTablePaginationDialogMemberRef.value.resetPage()
      }
      let param = {
        page: YTTablePaginationDialogMemberRef.value.getPage(),
        pageSize: YTTablePaginationDialogMemberRef.value.getPageSize()
      }
      dialogLoading.value = true
      let res = null
      if (cacheUserListKeyword.value) {
        res = await memberList(param, {phoneOrNickname: cacheUserListKeyword.value})
      } else {
        res = await memberList(param, {phoneOrNickname: null})
      }
      dialogMemberList.value = res.list
      dialogMemberTotal.value = parseInt(res.total)
      dialogLoading.value = false
    } catch (e) {
      console.log(e)
      dialogLoading.value = false
    }
  })
}

// 处理新增积分记录
const handleAdd = () => {
  try {
    open.value = true
    dialogFormRef.value.clearValidate()
  } catch (e) {
    console.log(e)
  }
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd" :disabled="!$handleHasBtnPermission('any', 'memberCreditLog:add')">新建积分记录</v-btn>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="4">
                    <v-text-field
                        v-model="formData.userId"
                        placeholder="请输入用户ID"
                        label="用户ID"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-select
                        ref="operatorListRef"
                        v-model="formData.crUserId"
                        :items="memberListArr"
                        item-title="username"
                        item-value="adminId"
                        label="操作人"
                        variant="outlined"
                        :no-data-text="'没有更多数据了~'"
                        @update:modelValue="handleSelectOperator"
                        :loading="operatorLoading"
                        placeholder="请选择操作人"
                    >
                      <template v-slot:prepend-item>
                        <div class="pd_l_1 pd_r_1 pd_t_1" style="width: 300px">
                          <v-text-field
                              v-model="operatorSelectKey"
                              placeholder="请输入操作人名称"
                              label="操作人名称"
                              variant="outlined"
                              clearable
                              append-inner-icon="mdi-magnify"
                              @click:append-inner="handleGetOperator('search')"
                              @keydown.enter="handleGetOperator('search')"
                              :disabled="operatorLoading"
                          ></v-text-field>
                        </div>
                        <v-divider class="mb-2"></v-divider>
                      </template>
                      <template v-slot:append-item>
                        <v-divider class="mb-2" v-if="memberTotal > 0"></v-divider>
                        <YTTablePagination v-if="memberTotal > 0" ref="YTTablePaginationMemberRef" :pageSize="5" :total="memberTotal" @page-change="handleChangeMemberPage"></YTTablePagination>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="3" offset="1">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('any', 'memberCreditLog:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('any', 'memberCreditLog:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.nickname=" { item } ">
            {{item.nickname ? item.nickname : "-"}}
          </template>

          <template v-slot:item.crUserName=" { item } ">
            {{item.type === 'SYSTEM' ? 'System' : item.crUserName}}
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :pageSize="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
  <el-dialog
      v-model="open"
      title="新建积分记录"
      width="600"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">新建积分记录</div>
    </template>
    <el-form
        ref="dialogFormRef"
        style="max-width: 100%"
        :model="dialogForm"
        :rules="dialogRules"
        label-width="auto"
        class="demo-ruleForm"
        size="large"
        status-icon
        v-loading="loading"
    >
      <el-form-item label="用  户：" prop="userId">
        <el-select
            v-model="dialogForm.userId"
            filterable
            remote
            reserve-keyword
            placeholder="选择用户"
            remote-show-suffix
            :remote-method="(keyword) => handleUserListRemoteSearch(keyword, 'search')"
            :loading="dialogLoading"
        >
          <el-option
              v-for="item in dialogMemberList"
              :key="item.userId"
              :label="`${item.nickname}(${item.phone})`"
              :value="item.userId"
          />
          <template #footer>
            <YTTablePagination ref="YTTablePaginationDialogMemberRef" :pageSize="5" :total="dialogMemberTotal" @page-change="handleChangeDialogMemberPage"></YTTablePagination>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="积  分：" prop="creditChange">
        <el-input-number style="width: 250px" placeholder="积分数值；正负整数" :precision="0" v-model="dialogForm.creditChange"></el-input-number>
      </el-form-item>
      <el-form-item label="操作人：" prop="operatorId">
        {{userInfo.username}}
      </el-form-item>
      <el-form-item label="备  注：" prop="reason">
        <el-input type="textarea" :rows="5" resize="none" show-word-limit :maxlength="200" placeholder="填写原因。字数小于等于200" v-model="dialogForm.reason"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <v-row>
        <v-col cols="5" offset="7">
          <div class="flex_right">
            <v-btn variant="elevated" @click="closeDialog">取消</v-btn>
            <v-btn class="mg_l_1" color="primary" variant="elevated" @click="submitDialog">确定</v-btn>
          </div>
        </v-col>
      </v-row>
    </template>
  </el-dialog>
</template>

<style scoped>

</style>
